import { Flex, Link } from "@jsq/ds/core";

export const ViewRoles = () => (
  <Flex flexDirection="row" justifyContent="flex-start">
    <Link
      to="/users/canopy-roles"
      shouldOpenInNewTab
      icon="arrow-up-right-from-square"
      iconPosition="right"
      iconVariant="solid"
    >
      View roles
    </Link>
  </Flex>
);
